/**
 * Shared logic to locate unique match text within a linear string, optionally
 * disambiguated by chunk text (chunk must contain the match).
 */

/** NBSP → space; offsets stay aligned with the original string. */
export const normalizeForMatchText = (s: string): string =>
  s.replace(/\u00a0/g, " ");

/**
 * Find [start, end) of the match in `haystack`.
 * When `chunkTrimmed` is set, prefers the occurrence inside the first chunk match (disambiguation).
 * Otherwise finds the first occurrence of the match text.
 */
export function findMatchRangeInHaystack(
  haystack: string,
  matchTrimmed: string,
  chunkTrimmed: string | undefined
): { start: number; end: number } | null {
  const h = normalizeForMatchText(haystack);
  const m = normalizeForMatchText(matchTrimmed);
  if (!m) {
    return null;
  }

  const findFirst = (hay: string, needle: string) => {
    const i = hay.indexOf(needle);
    return i === -1 ? null : { start: i, end: i + needle.length };
  };

  if (chunkTrimmed) {
    const c = normalizeForMatchText(chunkTrimmed);
    if (c.includes(m)) {
      const chunkPos = h.indexOf(c);
      if (chunkPos !== -1) {
        const rel = c.indexOf(m);
        if (rel !== -1) {
          const start = chunkPos + rel;
          return { start, end: start + m.length };
        }
      }
    }
  }

  return findFirst(h, m);
}
